/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitEntityNoDomainQueries
 */
export interface MonitEntityNoDomainQueries {
    /**
     * 
     * @type {string}
     * @memberof MonitEntityNoDomainQueries
     */
    entity_name?: string;
}

/**
 * Check if a given object implements the MonitEntityNoDomainQueries interface.
 */
export function instanceOfMonitEntityNoDomainQueries(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityNoDomainQueriesFromJSON(json: any): MonitEntityNoDomainQueries {
    return MonitEntityNoDomainQueriesFromJSONTyped(json, false);
}

export function MonitEntityNoDomainQueriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityNoDomainQueries {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entity_name': !exists(json, 'entity_name') ? undefined : json['entity_name'],
    };
}

export function MonitEntityNoDomainQueriesToJSON(value?: MonitEntityNoDomainQueries | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_name': value.entity_name,
    };
}

